export function isLassoFilterPolygon(polygon: { source?: string } | unknown): boolean {
  return (polygon as { source?: string })?.source === "selection";
}
